import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'no_NO',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '8b7325cc-981b-43e3-8438-076693b82fa0',
  ''
);
